var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_161_64187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.42454 0.0433753C6.21396 0.015784 7.83253 1.39535 8.13826 3.31755C8.25516 4.06251 8.07531 4.76149 7.77858 5.44208C7.27502 6.57333 6.60961 7.6218 5.86327 8.60589C5.13491 9.57159 3.69618 9.60837 2.94984 8.64268C2.10458 7.57581 1.38522 6.41698 0.87267 5.12938C-0.125449 2.65536 1.88877 0.015784 4.31663 0.0433753C4.3526 0.0433753 4.38857 0.0433753 4.42454 0.0433753ZM5.89923 3.88777C5.89923 3.01404 5.22483 2.31506 4.38857 2.31506C3.5613 2.31506 2.86891 3.01404 2.86891 3.86018C2.86891 4.7431 3.52533 5.44208 4.36159 5.45128C5.24281 5.45128 5.89923 4.77989 5.89923 3.88777Z",
    fill: "#9E9BA9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_161_64187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7.56233,
    height: 9.30748,
    fill: "white",
    transform: "translate(0.612305 0.0429688)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e7e05f89898951e48da6f3f00c0b8455.svg";
export { ForwardRef as ReactComponent };